import { Box, Flex, Text } from '@chakra-ui/react';
import { Fragment } from 'react';
import { useCopy } from '@/travo/i18n';

/** Airmail-striped band listing the app's eight tour stops. */
const TourBand = () => {
  const copy = useCopy();

  return (
    <Box as="section" aria-label="Travo">
      <Box className="airmail" h="10px" />
      <Flex
        bg="ink"
        color="paper"
        fontFamily="mono"
        fontSize={{ base: '13px', md: '14px' }}
        letterSpacing="0.18em"
        textTransform="uppercase"
        px={6}
        py="18px"
        wrap="wrap"
        justify="center"
        gap="10px 28px"
      >
        {copy.band.map((stop, i) => (
          <Fragment key={stop}>
            {i > 0 && (
              <Text as="span" color="sun" aria-hidden>
                ✦
              </Text>
            )}
            <Text as="span">{stop}</Text>
          </Fragment>
        ))}
      </Flex>
      <Box className="airmail" h="10px" />
    </Box>
  );
};

export default TourBand;
